import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useBreakpoint, useMediaAsset } from '~/composables';

interface Props {
  data: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryBannerV2',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: any };



const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isMobile } = useBreakpoint('md');

const backgroundImage = computed(() =>
  getAssetUrl(isMobile.value ? props.data.image : props.data.imageMobile),
);

return { __sfc: true,props, getAssetUrl, isMobile, backgroundImage }
}

})